export default __webpack_public_path__ + "static/media/cursor-crosshair.029ad98c.svg";